import { render, staticRenderFns } from "./Coaches.vue?vue&type=template&id=8a76f090&scoped=true"
import script from "./Coaches.vue?vue&type=script&lang=ts"
export * from "./Coaches.vue?vue&type=script&lang=ts"
import style0 from "./Coaches.vue?vue&type=style&index=0&id=8a76f090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a76f090",
  null
  
)

export default component.exports